import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import cookie from '../config/cookie'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageYOffset: 0,
    isLogin: cookie.get('isLogin'),
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    platform: '' // 平台
  },
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/index.js